// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';
import ProtectedRoute from './ProtectedRoute';
import ClientDetail from './ClientDetail';
import ClientCalendar from './ClientCalendar';
import AllCalendar from './AllCalendar';
import AdminPage from './AdminPage';
import AccountPortal from './AccountPortal';
import AdminAccounts from './admin/AdminAccounts';
import ChatbotPublic from './chatbot_public/ChatbotPublic';
import BookingPublicForm from './chatbot_public/BookingPublicForm';
import BookingConfirmation from './BookingConfirmation';

function App() {
    return (
        <Router>
            <div className="min-h-screen bg-gray-100 text-gray-800 font-sans">
                <Routes>
                    <Route path="/" element={<Login />} />

                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/client/:id"
                        element={
                            <ProtectedRoute>
                                <ClientDetail />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/client/:id/calendar"
                        element={
                            <ProtectedRoute>
                                <ClientCalendar />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/allcalendar"
                        element={
                            <ProtectedRoute>
                                <AllCalendar />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin"
                        element={<AdminPage />}
                    />
                    <Route
                        path="/account"
                        element={<AccountPortal />}
                    />
                    <Route
                        path="/admin/accounts"
                        element={<AdminAccounts />}
                    />
                    <Route
                        path="/chatbot"
                        element={<ChatbotPublic />}
                    />
                   
                    <Route
                        path="/booking"
                        element={<BookingPublicForm />}
                    />

                    <Route
                        path="/booking-confirmation"
                        element={<BookingConfirmation />}
                    />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
